module.exports = __webpack_public_path__ + "img/cs-logo.c61329de.png";